import { isEmpty } from '@chegg/utils';
import { accountTypeToPaymentMethods } from '../../../constants/PaymentTypes';
import { getSupportedPaymentMethods } from '../../../business/configManager/ConfigManager';
import { saveConfigs } from '../../ConfigState/ConfigState.actions';
import { setSelectedMop, updateMopList } from '../../MopOnFileState/MopOnFileState.actions';
import { setAppMode } from '../../AppModeState/AppModeState.actions';
import { AppMode } from '../../AppModeState/AppModeState.types';
import { batch } from 'react-redux';
/**
 *  When the price summary is updated, PM performs several actions
 * 1. Update the price summary used in the config.
 * 2. Recalculate the supported payment methods
 * 3. Strip out any invalid payment methods from redux
 * 4. Depending on the number of MOPs leftover, set the application mode
 * @param state
 * @param command
 * @param dispatch
 * @returns
 */
export var updatePricingCommand = function updatePricingCommand(params) {
  var command = params.command,
    state = params.state,
    dispatch = params.dispatch;
  if (!command.data || isEmpty(command.data)) return;
  var updatedPriceSummary = command.data;
  var currency = updatedPriceSummary.currency;
  var config = state.config,
    mopOnFile = state.mopOnFile;
  var paymentMethods = config.paymentMethods,
    priceSummary = config.priceSummary,
    isRecurly = config.isRecurly;
  var actions = [];
  var supportedPaymentMethods = getSupportedPaymentMethods(currency, paymentMethods);
  actions.push(saveConfigs({
    priceSummary: updatedPriceSummary,
    supportedPaymentMethods: supportedPaymentMethods
  }));
  if (!priceSummary && !isRecurly) {
    var _filteredMopsOnFile$;
    var filteredMopsOnFile = mopOnFile.paymentMethods.filter(function (method) {
      return supportedPaymentMethods.includes(
      //@ts-ignore
      accountTypeToPaymentMethods.get(method.accountType));
    });
    actions.push(updateMopList({
      paymentMethods: filteredMopsOnFile
    }));
    actions.push(setSelectedMop({
      mop: (_filteredMopsOnFile$ = filteredMopsOnFile[0]) !== null && _filteredMopsOnFile$ !== void 0 ? _filteredMopsOnFile$ : {}
    }));
    if (filteredMopsOnFile.length > 0) {
      actions.push(setAppMode({
        mode: AppMode.DEFAULT_MOP,
        goBackMode: AppMode.DEFAULT_MOP
      }));
    } else {
      actions.push(setAppMode({
        mode: AppMode.ADD,
        goBackMode: AppMode.DEFAULT_MOP
      }));
    }
  }
  batch(function () {
    actions.forEach(function (action) {
      return dispatch(action);
    });
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/commands/updatePricingCommand.js
// module id = 4403
// module chunks = 11